<template>
  <div>
    <NavCN/>
    <div class="main-container">
      <section class="middle-image">
        <img src="../../../public/img/background-company.jpg">
      </section>
      <section class="large-company-introduce">
        <div class="company-left">
          <img src="../../../public/img/background-company-left.jpg">
        </div>
        <div class="company-right">
          <div class="company-desc">
            <h2>德鑫化工产品销售有限公司</h2>
            <p>
              德鑫 ：中国食品添加剂主要供应商
            </p>
            <p>
              二〇一三年公司业务活动主要是在中国境内。从事食品添加剂销售活动国内市场覆盖30个省，市，自治区。而且业务量逐年攀升。
            </p>
            <p>
              二〇一四年，公司邀请有关专家，对产品质量，销售网络，业务人才，销售服务进行了多方面的论证。一致认为：开展国际业务扩大经营范围的时机已经成熟。随决定申请国际业务进出口权并获得成功的运作。
            </p>
            <p>
              目前，德鑫正象东方冉冉升起的一轮红日，充满着朝气和活力，满怀信心地向中国走来，向世界走来。
            </p>
          </div>
        </div>
      </section>
    </div>
    <FooterCN/>
  </div>
</template>

<script>

import NavCN from '@/components/nav-cn.vue'
import FooterCN from '@/components/footer-cn.vue'

export default {
  name: 'companyCN',
  components: {
    NavCN,
    FooterCN
  }
}
</script>

<style lang="scss">
  .main-container {
    max-width: 1580px;
    margin: 0 auto;
    .middle-image {
      background: #333;
      width: 100%;
      height: 100%;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
        opacity: .7;
      }
    }
    .large-company-introduce {
      position: relative;
      display: flex;
      padding-top: 5px;
      padding-bottom: 40px;
      width: 100%;
      align-items: center;
      @media(max-width: 992px) {
        display: block;
      }
      .company-left {
        width: 55%;
        img {
          width: 100%;
        }
        @media(max-width: 992px) {
          width: 100%;
        }
      }
      .company-right {
        position: relative;
        width: 45%;
        @media(max-width: 992px) {
          width: 100%;
        }
        .company-desc {
          width: 420px;
          margin: 0 auto;
          @media(max-width: 992px) {
            width: 80%;
          }
          h2 {
            margin-top: 0;
            margin-bottom: 20px;
            font-size: 32px;
            font-weight: 300;
            line-height: 40px;
            color: rgb(51, 51, 51);
          }
          p {
            margin: 5px 0;
            text-align: left;
            text-indent:2em;
            font-size: 16px;
            font-weight: 400;
            line-height: 26px;
            color: rgb(119, 119, 119);
          }
        }
      }
    }
  }

</style>
